import { useQuery } from 'react-query';
import http from '@framework/utils/http';
import { API_ENDPOINTS } from '@framework/utils/api-endpoints';
export interface UploadCategory {
  id: any;
  category: string;
  label: string;
  count: number;
}
export interface UploadItem {
  id: number;
  category: string;
  title: string;
  file: string;
}
export const fetchUploadCategories = async (): Promise<UploadCategory[]> => {
  const {
    data
  } = await http.get(API_ENDPOINTS.UPLOAD_CATEGORY);
  return data;
};
export const useUploadCategoriesQuery = () => {
  return useQuery<UploadCategory[], Error>(['upload/categories'], fetchUploadCategories, {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    keepPreviousData: true,
    staleTime: 15 * 60 * 1000,
    cacheTime: 15 * 60 * 1000
  });
};
export const fetchUploadsByCategory = async (category: string): Promise<UploadItem[]> => {
  const {
    data
  } = await http.get(`${API_ENDPOINTS.UPLOAD_UPLOAD}?category=${encodeURIComponent(category)}`);
  return data;
};
export const useUploadsByCategoryQuery = (category: string) => {
  return useQuery<UploadItem[], Error>(['upload/uploads', category], () => fetchUploadsByCategory(category), {
    enabled: !!category,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    keepPreviousData: true
  });
};